import { render, staticRenderFns } from "./dinad.vue?vue&type=template&id=2279c932&scoped=true&"
import script from "./dinad.vue?vue&type=script&lang=js&"
export * from "./dinad.vue?vue&type=script&lang=js&"
import style0 from "./dinad.vue?vue&type=style&index=0&id=2279c932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279c932",
  null
  
)

export default component.exports